import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/content";
import { Reveal } from "./Reveal";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const go = (dir) => setI((prev) => (prev + dir + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section className="bg-[#1E3A2B] px-6 py-28" data-testid="testimonials">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <p className="eyebrow text-[#DCBB6C]">What Others Say</p>
          <h2 className="font-serif-d text-4xl md:text-5xl text-[#FAF4E9] tracking-tight mt-3">Words from the <span className="italic-emph text-[#E7AEB4]">room.</span></h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-[280px_1fr] gap-10 items-center">
          <div className="relative mx-auto md:mx-0">
            <div className="absolute -inset-3 bg-[#C77E88] translate-x-3 translate-y-3" />
            <AnimatePresence mode="wait">
              <motion.img key={t.photo} src={t.photo} alt={t.name}
                initial={{ opacity: 0, scale: 1.05 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
                transition={{ duration: 0.4 }} className="relative w-64 h-72 object-cover" />
            </AnimatePresence>
          </div>

          <div>
            <Quote className="text-[#DCBB6C]" size={40} />
            <AnimatePresence mode="wait">
              <motion.div key={i} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.4 }}>
                <p className="font-serif-d text-2xl md:text-3xl text-[#FAF4E9] leading-snug mt-4">{t.quote}</p>
                <p className="mt-6 text-[#DCBB6C] font-semibold">— {t.name}</p>
                <p className="text-xs text-[#FAF4E9]/60 uppercase tracking-widest mt-1">{t.role}</p>
              </motion.div>
            </AnimatePresence>

            <div className="flex items-center gap-3 mt-10">
              <button data-testid="testimonial-prev" onClick={() => go(-1)} className="border border-[#FAF4E9]/30 hover:bg-[#FAF4E9]/10 p-3 transition-colors text-[#FAF4E9]"><ChevronLeft size={18} /></button>
              <button data-testid="testimonial-next" onClick={() => go(1)} className="border border-[#FAF4E9]/30 hover:bg-[#FAF4E9]/10 p-3 transition-colors text-[#FAF4E9]"><ChevronRight size={18} /></button>
              <div className="flex gap-2 ml-3">
                {TESTIMONIALS.map((t, idx) => (
                  <button key={t.name} onClick={() => setI(idx)} className={`h-1.5 transition-all ${idx === i ? "w-8 bg-[#DCBB6C]" : "w-3 bg-[#FAF4E9]/30"}`} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
